import { z } from 'zod';

// Environment variables schema
const envSchema = z.object({
  OPENAI_API_KEY: z.string().min(1),
  SAM_GOV_API_KEY: z.string().min(1),
  PERPLEXITY_API_KEY: z.string().min(1),
});

// Validate environment variables
const env = envSchema.safeParse({
  OPENAI_API_KEY: import.meta.env.VITE_OPENAI_API_KEY,
  SAM_GOV_API_KEY: import.meta.env.VITE_SAM_GOV_API_KEY,
  PERPLEXITY_API_KEY: import.meta.env.VITE_PERPLEXITY_API_KEY,
});

if (!env.success) {
  console.error('❌ Invalid environment variables:', env.error.flatten().fieldErrors);
  throw new Error('Invalid environment variables');
}

export const AI_CONFIG = {
  openai: {
    apiKey: env.data.OPENAI_API_KEY,
    model: 'gpt-4-turbo-preview',
    temperature: 0.7,
  },
  samGov: {
    apiKey: env.data.SAM_GOV_API_KEY,
    baseUrl: 'https://api.sam.gov/opportunities/v2',
  },
  perplexity: {
    apiKey: env.data.PERPLEXITY_API_KEY,
    baseUrl: 'https://api.perplexity.ai',
  },
} as const;

// Rate limiting configuration
export const RATE_LIMITS = {
  openai: {
    maxRequestsPerMinute: 60,
    maxTokensPerMinute: 90000,
  },
  samGov: {
    maxRequestsPerMinute: 100,
  },
  perplexity: {
    maxRequestsPerMinute: 60,
  },
} as const;

// Feature flags for AI capabilities
export const AI_FEATURES = {
  contractRecommendations: true,
  proposalGeneration: true,
  complianceTracking: true,
  marketIntelligence: true,
  successPrediction: true,
  documentGeneration: true,
} as const;

// AI model configurations
export const MODEL_CONFIGS = {
  recommendation: {
    model: 'gpt-4-turbo-preview',
    temperature: 0.7,
    max_tokens: 1000,
  },
  compliance: {
    model: 'gpt-4-turbo-preview',
    temperature: 0.3,
    max_tokens: 2000,
  },
  proposal: {
    model: 'gpt-4-turbo-preview',
    temperature: 0.6,
    max_tokens: 4000,
  },
} as const;